import React, { useMemo, useRef } from "react";
import { FormGroup, Input, Label } from "reactstrap";

export const RadioInput = ({
  field,
  label,
  classNames,
  htmlFor,
  onChange,
  ...restProps
}) => {
  // eslint-disable-next-line react-hooks/purity
  const id = useRef(Math.random().toString(36).slice(2));
  const inputId = useMemo(
    () => htmlFor || `radio-${field?.name || "input"}-${id.current}`,
    [htmlFor, field?.name],
  );

  return (
    <FormGroup check className={classNames}>
      <Input
        {...field}
        {...restProps}
        id={inputId}
        onChange={onChange || field.onChange}
      />
      <Label check htmlFor={inputId} className={restProps.labelclass}>
        {label}
      </Label>
    </FormGroup>
  );
};
